import React from 'react'
import styled from 'styled-components'
import { FiArrowRight } from 'react-icons/fi'
import { useTranslation } from '../../../../../hooks'
import ButtonSpinnerWhite from '../../../../layout/spinner/ButtonSpinnerWhite'

const MCDONALDS_GREEN = '#304E38'
const MCDONALDS_YELLOW = '#FFCC02'

interface StyledButtonProps {
    $active: boolean
    $opacity: number
}

const StyledButton = styled.button<StyledButtonProps>`
    height: 5rem;
    opacity: ${({ $opacity }) => $opacity};
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 190px;
    background: ${MCDONALDS_GREEN};
    border-radius: 10rem;
    border: none;
    transition: all 0.2s;

    &:hover {
        opacity: ${({ $active }) => $active && '0.8 !important'};
    }

    &:hover .next-btn-arrow-icon {
        transform: ${({ $active }) => $active && 'translateX(30%)'};
    }
`

const ButtonText = styled.p`
    font-size: 1.6rem;
    color: ${MCDONALDS_YELLOW};
    font-weight: medium;
`

const ArrowIcon = styled(FiArrowRight)`
    color: ${MCDONALDS_YELLOW};
    size: 1.9rem;
    margin-left: 0.8rem;
    transition: all 0.2s;
`

interface McDonaldsNextButtonProps {
    isActive: boolean
    isLoading?: boolean
    handleOnClick?: () => void
}

const McDonaldsNextButton: React.FC<McDonaldsNextButtonProps> = ({
    isActive,
    isLoading = false,
    handleOnClick,
}) => {
    const translation = useTranslation()

    return (
        <StyledButton
            $opacity={!isActive ? 0.2 : 1}
            $active={isActive}
            disabled={!isActive}
            onClick={() => isActive && handleOnClick && handleOnClick()}
        >
            {!isLoading ? (
                <>
                    <ButtonText data-testid="next-button">
                        {translation.nextButton.nextStep}
                    </ButtonText>
                    <ArrowIcon className="next-btn-arrow-icon" />
                </>
            ) : (
                <ButtonSpinnerWhite overrideColor={MCDONALDS_YELLOW} />
            )}
        </StyledButton>
    )
}

export default McDonaldsNextButton
